<script setup>
import {useAuth0} from "@auth0/auth0-vue";

const {loginWithRedirect} = useAuth0();

const login = (isRedirect) => {
  const options = isRedirect ? {
    authorizationParams: {screen_hint: 'signup'}
  } : {};
  loginWithRedirect(options);
};
</script>

<template>
  <div class="options-container light-teal-bg">
    <div class="card">
      <div class="top-icon-container">
        <font-awesome-icon icon="home" class="top-icon home-icon"/>
      </div>
      <div class="card-body">
        <h5 class="card-title title-font">Ready to Add a Home?</h5>
        <button class="btn btn-primary" @click="login(true)">Create a Free Account</button>
        <p>Already have an account?</p>
        <button class="btn btn-primary" @click="login(false)">Log In</button>
      </div>
    </div>
    <div class="card">
      <div class="top-icon-container">
        <font-awesome-icon icon="search" class="top-icon search-icon"/>
      </div>
      <div class="card-body">
        <h5 class="card-title title-font">Just Browsing?</h5>
        <router-link to="/search">
          <button class="btn btn-secondary">Search for Homes</button>
        </router-link>
        <a href="https://www.facebook.com/groups/140590951577780/" target="_blank">
          <button class="btn btn-secondary">Join our Facebook Community</button>
        </a>
      </div>
    </div>
    <img class="bg-img-bottom" src="@/assets/landscape_bw.png"/>
  </div>
</template>

<style scoped>
.options-container {
  display: flex;
  position: relative;
  padding: 2.5rem 1rem;
  overflow: hidden;
}

.options-container button {
  width: 100%;
  height: 5rem;
  font-size: x-large;
  margin-bottom: 1rem;
}

.options-container a {
  width: 100%;
}

.top-icon-container {
  font-size: 16vh;
  text-align: center;
  margin-top: -6rem;
}

.home-icon {
  color: #006060;
}

.search-icon {
  color: #6c757d;
}

.card {
  width: 50%;
  margin: 5rem 1rem 1rem 1rem;
  padding: 1rem;
  align-items: center;
  z-index: 1;
}

.card-title {
  text-transform: capitalize;
  font-size: xx-large;
  text-align: center;
}

.card-body {
  width: 60%;
  padding-top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

p {
  margin-bottom: 0.5rem;
  font-size: small;
}

@media screen and (max-width: 600px) {
  /*logged out view (mobile)*/
  .options-container {
    flex-direction: column;
    padding: 0;
  }

  .top-icon-container {
    font-size: 10vh;
    text-align: center;
    margin-top: 0;
  }

  .card {
    width: 100%;
    margin: 0;
    border: none;
    padding: 0;
  }

  .card-body {
    width: 100%;
    padding: 0;
  }
}
</style>